<template>
  <a-modal
    :title="null"
    :visible="!!visible"
    wrapClassName="demo__AuthModal--con"
    :getContainer="container"
    dialogClass="demo__AuthModal"
    @cancel="$store.dispatch('updateAuthModalStatus', false)"
    :footer="null"
    :mask="false"
    data-testid="auth-modal"
  >
    <component :is="authModalStatusCache" />
  </a-modal>
</template>

<script>
import { mapGetters } from "vuex";

import Login from "./components/Login";
import Reg from "./components/Reg";
import ResetPassword from "./components/ResetPassword";

export default {
  components: {
    Login,
    Reg,
    ResetPassword,
  },
  data() {
    return {
      visible: false,
      authModalStatusCache: false,
      container: () => document.getElementById("app"),
      timeout: undefined,
    };
  },
  computed: {
    // authModalStatusComponent() {
    //     return this.authModalStatusCache ? import("./components/"+this.authModalStatusCache) : undefined;
    // },
    ...mapGetters(["authModalStatus"]),
  },
  watch: {
    authModalStatus(val) {
      clearTimeout(this.timeout);
      this.visible = val;
      if (val) {
        this.authModalStatusCache = val;
      } else {
        this.timeout = setTimeout(() => {
          this.authModalStatusCache = false;
        }, 500);
      }
    },
  },
};
</script>
